import * as PopoverPrimitive from "@radix-ui/react-popover";
import { type ComponentProps } from "react";

import { cn } from "../../utils/cn.util";
import { useFloatingPortalContainer } from "../portal/FloatingPortalContainerContext";

export type PopoverContentProps = ComponentProps<typeof PopoverPrimitive.Content> & {
  container?: HTMLElement | null;
};

const Content = ({ ref, className, align = "center", sideOffset = 4, container, ...props }: PopoverContentProps) => {
  const floatingContainer = useFloatingPortalContainer();

  return (
    <PopoverPrimitive.Portal container={container ?? floatingContainer ?? undefined}>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          "z-50 origin-(--radix-popover-content-transform-origin) rounded-lg border border-neutral-96 bg-white shadow-lg outline-hidden data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
          "w-(--radix-popover-trigger-width)",
          "max-h-(--radix-popover-content-available-height)",
          className
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
};
Content.displayName = PopoverPrimitive.Content.displayName;

export default Content;
